import React from 'react'
import styles from '~/styles/atoms/title/title.module.scss'
import { useColor } from '~/hooks/server/color'
import { ChildProps } from '~/common/define/props'

const MainTitle = ({children}: ChildProps) => {
  const color = useColor()
  return (
    <>
      <h1 className={styles.main}>
        {children}
      </h1>
      <style jsx>{`
        h1 {
          border-color: ${color};
        }
      `}</style>
    </>
  )
}

export default MainTitle